import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'

export const StatisticsBlock = styled(GriddedContentBlock)`
  margin-top: 84px;
  position: relative;
  font-size: 2.8rem;
`

export const TextContainer = styled.div`
  background-color: var(--graphic-accent-purple-1);
  grid-column: span 12;
  padding: 65px 32px 48px;
  text-align: center;

  @media ${DEVICE.tabletL} {
    grid-column: 2 / 12;
    padding: 78px 10% 22px;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const Title = styled.h2`
  font-weight: 300;
  font-size: 3.6rem;
  line-height: 1.3;
  margin-bottom: 24px;
  color: var(--content-background-dark-blue);

  @media ${DEVICE.tabletL} {
    font-size: 6.4rem;
    line-height: 1.36;
    margin-bottom: 26px;
  }
`

export const SubTitle = styled.h3`
  color: var(--content-background-dark-blue);
  font-size: 1.8rem;
  line-height: 1.4;
  margin-bottom: 10px;

  @media ${DEVICE.tabletL} {
    font-size: 2.4rem;
    line-height: 1.375;
  }
`

export const Cite = styled.div`
  font-size: 1.8rem;
  line-height: 1.4;
  font-style: italic;
  margin-top: -10px;
  color: var(--content-background-dark-blue);

  @media ${DEVICE.tabletL} {
    font-size: 2.4rem;
    line-height: 1.375;
    margin-bottom: 26px;
  }
`
export const Sign = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 248px;
  height: 72px;
  top: -36px;
  background-color: var(--content-background-light);

  @media ${DEVICE.tabletL} {
    width: 360px;
    height: 87px;
    top: -44px;
  }

  p {
    font-size: 1.4rem;
    line-height: 1.7;
    color: var(--content-background-dark-blue);
    text-align: center;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-top: 35px;

    @media ${DEVICE.tabletL} {
      font-size: 1.8rem;
      line-height: 1.3;
      margin-top: 48px;
    }
  }
`

export const IconContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  top: -25px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media ${DEVICE.tabletL} {
    width: 69px;
    height: 68px;
    top: -34px;
  }
`
